import { QueryObserverResult, useQuery } from "react-query";

import { acatsAPIInstance } from "../api";

type AssetClass = "EQUITY" | "CASH" | "OPTION" | "OTHER";

type AssetPosition = "LONG" | "SHORT";

type AssetStatus =
  | "NOT_VALIDATED"
  | "REQUESTED"
  | "DELETED"
  | "SETTLED"
  | "REVERSED"
  | "INTERFACE_REJECTED";

export interface AcatsAsset {
  isin?: string;
  asset_class: AssetClass;
  asset_description: string;
  status: AssetStatus;
  position: AssetPosition;
  quantity?: string;
  amount?: string;
  currency_code?: string;
  rejection_message?: string;
}

export const listAcatsTransferAssets = async (
  accountID: string,
  acatsID: string
): Promise<AcatsAsset[]> => {
  const res = await acatsAPIInstance.get<AcatsAsset[]>(
    `/acats/${accountID}/${acatsID}/assets`
  );

  return res.data;
};

export const useAcatsAssets = (
  accountID: string,
  acatsID: string
): QueryObserverResult<AcatsAsset[]> =>
  useQuery(["acats", accountID, acatsID, "assets"], () =>
    listAcatsTransferAssets(accountID, acatsID)
  );
